export default "__VITE_ASSET__aae28321__"